import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

import { useState } from "react";
import MgpButton from "../../../elements/MgpButton/MgpButton";
import MgpFormInput from "../../../elements/MgpFormInput/MgpFormInput";
import MgpMessage from "../../../elements/MgpMessage/MgpMessage";
import { IForgetPasswordRequest } from "../../../services/model";
import { Link } from "react-router-dom";
import { baseAppPath, RECAPTCHA_KEY } from "../../../config/GlobalConfig";
import { forgetPassword } from "../../../services/AuthService";
import { AxiosError } from "axios";
import { useGoogleReCaptcha } from "react-google-recaptcha-hook";

export default function ForgetPasswordEntrepriseComponent() {
  const validationSchema = Yup.object().shape({
    administrativeNumber: Yup.string()
      .required("Veuillez renseigner votre matricule"),
    email: Yup.string()
      .required("Veuillez renseigner votre email")
      .email("Votre email est incorrect"),
  });

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);

  const [success, setSuccess] = useState<boolean>(false);

  const { executeGoogleReCaptcha } = useGoogleReCaptcha(
    `${RECAPTCHA_KEY}`,
    {
      language: 'fr',
      enterprise: true,
      recaptchaNet: true, 
    }
  );

  const {
    register,
    handleSubmit, watch,
    formState: { errors, isSubmitting, isDirty },
  } = useForm<IForgetPasswordRequest>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      administrativeNumber: "",
      email: "",

    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: IForgetPasswordRequest) => {
    console.log("click");
    setErrorMsg(null);
    setLoading(true);
    try {
      const recaptchaToken = await executeGoogleReCaptcha("resetPassword");
      console.log(recaptchaToken);
      data.recaptchaToken = recaptchaToken;
      await forgetPassword("EE", data);
      setSuccess(true);
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && (err.response.status === 401 || err.response.status === 400 || err.response.status === 403)) {
        setErrorMsg("Aucun compte client ne correspond à ces informations.");
      } else {
        setErrorMsg("Une erreur technique est survenue. Veuillez réessayer ultérieurement");
      }
    }

  };

  return (
    <>
    {success&&(<>
      <MgpMessage type="success" message="Si votre information est valide, vous devez recevoir un email pour réinitialiser le mot de passe" hasCloseBtn={false}/>
      <div className="wrapper-cta-inline m-y-lg"> 
        <Link to={baseAppPath} className="cta-bleu text ta-center">Me connecter</Link>
      </div>
      </>
    )}
    {!success&&<form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={false}/>}
      <div className="form-group">
        <MgpFormInput
          label="Mon matricule"
          type="text"
          register={register}
          id="administrativeNumber"
          
          icon="account"
          errors={errors}
          disabled={isSubmitting || loading}
        />
        
      </div>
      <div className="form-group">
        <MgpFormInput
          label="Mon email"
          type="text"
          register={register}
          id="email"
          icon="mail"
          errors={errors}
          disabled={isSubmitting || loading}
        />
        <p className="text mt-md mb-md">Vous recevrez un email comportant un lien pour saisir votre nouveau mot de passe</p>
      </div>
      
      <div className="form-group">
        <MgpButton
          id="submitButton"
          type="submit"
          text="Envoyer"
          disabled={isSubmitting || loading} loading={isSubmitting || loading}
        />
      </div>
      
    </form>}
    </>
  );
}
